import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  CircularProgressbar,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { flatFacilitatorRoutes } from './flow';

const Footer = ({
  handleBack,
  handleNext,
  beginningOfProgram,
  disableNext = false,
  nextLabel = 'Next',
  routes = flatFacilitatorRoutes,
}) => {
  const location = useLocation();
  const currentRouteIndex = routes.findIndex(
    (route) => route.fullUrl === location.pathname,
  );
  const progressPercent =
    currentRouteIndex >= 0
      ? Math.round(
          ((currentRouteIndex + 1) / routes.length) * 100,
        )
      : 0;

  return (
    <footer
      className='bg-light-blue grid grid-cols-[1fr_auto_1fr] items-center gap-4 p-4
        sticky bottom-0 left-0 right-0 z-10
    '
    >
      <div className='flex justify-start'>
        {!beginningOfProgram && (
          <button
            onClick={handleBack}
            className='bg-dark-blue text-white px-4 py-2 rounded hover:bg-purple transition-colors duration-300 text-lg'
          >
            Back
          </button>
        )}
      </div>
      <div className='flex justify-center'>
        <div className='h-14 w-14 rounded-full bg-white p-1 shadow-sm ring-1 ring-slate-200'>
          <div className='relative h-full w-full'>
            <CircularProgressbar
              value={progressPercent}
              styles={buildStyles({
                pathColor: '#378abd',
                trailColor: '#d7e4ec',
              })}
            />
            <div className='absolute inset-0 flex items-center justify-center text-xs font-bold text-slate-800'>
              {progressPercent}%
            </div>
          </div>
        </div>
      </div>
      <div className='flex justify-end'>
        <button
          onClick={handleNext}
          disabled={disableNext}
          className={`px-4 py-2 rounded transition-colors duration-300 text-lg ${
            disableNext
              ? 'bg-gray-400 text-white cursor-not-allowed pointer-events-none'
              : 'bg-dark-blue text-white hover:bg-purple'
          }`}
        >
          {nextLabel}
        </button>
      </div>
    </footer>
  );
};

export default Footer;
